import { React, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './i18n'
import About from './pages/About'
import Blog from './pages/Blog'
import BlogDetails from './pages/BlogDetails'
import CaseStudyDetails from './pages/CaseStudyDetails'
import Contact from './pages/Contact'
import Home from './pages/Home'
import Services from './pages/Services'
import Service from './pages/Service'
import Solutions from './pages/Solutions'
import Solution from './pages/Solution'
import ScrollToTop from 'react-scroll-to-top'
import AOS from 'aos'
import 'aos/dist/aos.css'
// import ServiceDetails from './pages/ServiceDetails'
import i18n from './i18n'
import LangProvider from './context/langContext'
import TeamDetailsGroup from './components/SolutionDetailsGroup'
import Terms from './pages/Terms'
import PrivacyPolicy from './pages/PrivacyPolicy'

function App() {
  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: 'ease',
      once: true,
    })
    AOS.refresh()
  }, [])

  console.log(i18n.language)

  useEffect(() => {
    const updateDirection = () => {
      const dir = i18n.dir(i18n.language)
      document.documentElement.setAttribute('dir', dir)
    }

    // Initial direction setup
    updateDirection()

    // Subscribe to language changes
    i18n.on('languageChanged', updateDirection)

    // Cleanup function
    return () => {
      i18n.off('languageChanged', updateDirection)
    }
  }, [i18n])
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/blog-details" element={<BlogDetails />} />
          <Route
            exact
            path="/case-study-details"
            element={<CaseStudyDetails />}
          />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/service/:id" element={<Service />} />
          <Route exact path="/solution/:id" element={<TeamDetailsGroup />} />
          <Route exact path="/solutions" element={<Solutions />} />
          <Route exact path="/solution" element={<Solution />} />
          <Route exact path="/termsandconditions" element={<Terms />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
        </Routes>
        <ScrollToTop smooth color="#246BFD" />
      </BrowserRouter>
    </LangProvider>
  )
}

export default App
